import React from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import Spinner from 'shared/components/spinners/Spinner';
import QuickTip from 'shared/components/QuickTip';
import {AssigneeSelectorMenu} from 'main/components';
import PdfPreviewState from 'main/components/pdf/preview/state/PdfPreviewState';
import PageControls from './PageControls';
import {withState} from 'shared/core';

const Loading = observer(({uiState, width}) => {
  if (!uiState.loading) return null;

  return (
    <div
      style={{width: `${width}px`}}
      className='absolute center mx-auto bg-white py3 top-0'>
      <Spinner/>
    </div>
  );
});

const PdfError = ({errorMessage}) => {
  return (
    <div className='m2'>
      <QuickTip
        trait='error'
        header={<FormattedMessage id='components.pdf.Error Viewing PDF'/>}
      >
        <FormattedMessage id={errorMessage}/>
      </QuickTip>
    </div>
  );
};


class PdfPreview extends React.Component {
  async componentDidMount() {
    this.props.uiState.loadPdf();
    document.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown = (e) => {
    const {uiState} = this.props;

    if(e.key === 'Escape' && uiState.fullScreen) {
      uiState.exitFullScreen();
    }
  };

  render() {
    const {
      width,
      className,
      renderOnPasswordError,
      selectedAnnotation,
      assigneeSelectorMenuPosition,
      onAssigneeChanged,
      employees,
      hideAssigneeSelector,
      uiState
    } = this.props;
    const {errors, viewerContainerId} = uiState;

    if (errors.browserNotSupported) {
      return <PdfError errorMessage={errors.browserNotSupported}/>;
    }

    if (errors.passwordProtected) {
      const PasswordError = renderOnPasswordError;
      return <PasswordError/>;
    }

    return (
      <div className={uiState.fullScreen ? 'FullScreenPDF' : className}
           style={{width: uiState.fullScreen ? '100%' : `${parseInt(width) + 2}px`}}
      >
        <PageControls uiState={uiState}/>
        <div id='pdfViewerContainer' className='relative'>
          {!hideAssigneeSelector && <AssigneeSelectorMenu
            employees={employees}
            isOpen={!!selectedAnnotation}
            assignee={selectedAnnotation?.assignee}
            onChange={onAssigneeChanged}
            position={assigneeSelectorMenuPosition}
            selectedFieldType={selectedAnnotation?.descriptor.annotationType === 'variable' ? 'mergeField' : 'input'}
          />}
          <div id={viewerContainerId} className={`ViewerContainer ${(uiState.fullScreen ? 'border-top ' : 'border rounded-bottom ')}`}>
            <div id='viewer' className='pdfViewer'/>
          </div>
          {uiState.includeFabricCanvas && <canvas
            id='fabric-canvas'
            className='absolute'
            width={width}>
          </canvas>}
        </div>
        <Loading uiState={uiState} width={width}/>
      </div>
    );
  }
}

PdfPreview.defaultProps = {
  width: 798,
  className: 'relative',
  fullScreenOption: false,
  includeFabricCanvas: false,
  renderOnPasswordError: () => null
};

export default withState(observer(PdfPreview), PdfPreviewState);
